import PopOptionState from '../store/schema/PopOptionState';
import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getPopImapConfiguration } from 'owa-popimap-configuration';
import PopImapConfigurationState from 'owa-popimap-configuration/lib/store/schema/PopImapConfigurationState';
import { select } from 'satcheljs/lib/legacy';

export interface IsPopOptionDirtyState {
    optionState: PopOptionState;
    popImapConfigurationState: PopImapConfigurationState;
}

export default select<IsPopOptionDirtyState>({
    optionState: () => store,
    popImapConfigurationState: () => getPopImapConfiguration(),
})(function isPopOptionDirty(state?: IsPopOptionDirtyState) {
    if (!state.popImapConfigurationState) {
        return false;
    }
    let popEnabled = getFallbackValueIfNull(
        state.optionState.popEnabled,
        state.popImapConfigurationState.popEnabled
    );
    let popMessageDeleteEnabled = getFallbackValueIfNull(
        state.optionState.popMessageDeleteEnabled,
        state.popImapConfigurationState.popMessageDeleteEnabled
    );

    return (
        popEnabled !== state.popImapConfigurationState.popEnabled ||
        popMessageDeleteEnabled !== state.popImapConfigurationState.popMessageDeleteEnabled
    );
});
